// extracted by mini-css-extract-plugin
export default {"separator":"Slider_separator__7EGsL"};